import { Box, Typography } from '@mui/material'
import { C1Dialog, C1DialogContent, C1DialogTitle } from 'components/core/dialog/C1Dialog'
import {
    ReviewStylePickerBody,
} from 'components/pages/my_tasks/access_reviews/common/review-style-picker/index'
import { ReviewStylePickerBodyProps } from 'components/pages/my_tasks/access_reviews/common/review-style-picker/ReviewStylePickerBody'
import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

type ReviewStylePickerModalProps = {
    close: () => void
}

export const ReviewStylePickerModal: FC<ReviewStylePickerBodyProps & ReviewStylePickerModalProps> = ({
    accessReviewID,
    recommendedStyle,
    close,
}) => {
    return (
        <C1Dialog open onClose={close} maxWidth="md">
            <C1DialogTitle>
                <Box>
                    <Typography component="div" variant="h4" pb={1}>
                        <FormattedMessage
                            id="review_style_picker_modal_title"
                            defaultMessage="How do you want to view your reviews?"
                        />
                    </Typography>
                    <Typography>
                        <FormattedMessage
                            id="review_style_picker_modal_subtitle"
                            defaultMessage="You can switch to a different option at any time."
                        />
                    </Typography>
                </Box>
            </C1DialogTitle>
            <C1DialogContent>
                <ReviewStylePickerBody
                    accessReviewID={accessReviewID}
                    recommendedStyle={recommendedStyle}
                    onChange={close}
                />
            </C1DialogContent>
        </C1Dialog>
    )
}
